import { extractErrorInfo } from '@src/utility/error';
import { LogManager } from '@src/utility/Logger';

import type { WarmedRenderer } from '@src/services/WarmedRenderer';

const logger = LogManager.getLogger('store:CompositionScopeService');

/**
 * Owns composition-scope state and renderer scope orchestration.
 */
export default class CompositionScopeService {
  private activeCompositionId: string | null = null;

  private rendererCompositionId: string | null = null;

  getActiveCompositionId(): string | null {
    return this.activeCompositionId;
  }

  setActiveCompositionId(compositionId: string | null): void {
    this.activeCompositionId = compositionId;
  }

  getRendererCompositionId(): string | null {
    return this.rendererCompositionId;
  }

  setRendererCompositionId(compositionId: string | null): void {
    this.rendererCompositionId = compositionId;
  }

  hasScopedComposition(): boolean {
    return !!this.activeCompositionId || !!this.rendererCompositionId;
  }

  shouldResetOnDeselect(): boolean {
    return (
      !!this.activeCompositionId &&
      this.activeCompositionId === this.rendererCompositionId
    );
  }

  async exitScope(renderer?: WarmedRenderer): Promise<void> {
    if (!this.activeCompositionId && !this.rendererCompositionId) {
      return;
    }

    this.activeCompositionId = null;

    try {
      await renderer?.setActiveComposition(null);
    } catch (err) {
      logger.warn('Failed to exit composition scope', {
        error: extractErrorInfo(err),
      });
    }
  }
}
